import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://filemingle.com';

export default function SEOHead({ tool }) {
  const canonical = `${SITE_URL}/${tool.slug}`;

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: tool.faqs.map(({ q, a }) => ({
      '@type': 'Question',
      name: q,
      acceptedAnswer: { '@type': 'Answer', text: a },
    })),
  };

  const softwareSchema = {
    '@context': 'https://schema.org',
    '@type': 'SoftwareApplication',
    name: `FileMingle — ${tool.h1}`,
    applicationCategory: 'UtilitiesApplication',
    operatingSystem: 'Web',
    offers: { '@type': 'Offer', price: '0', priceCurrency: 'USD' },
    url: tool.appUrl,
  };

  return (
    <Helmet>
      <title>{tool.metaTitle}</title>
      <meta name="description" content={tool.metaDescription} />
      <link rel="canonical" href={canonical} />
      <meta property="og:title" content={tool.metaTitle} />
      <meta property="og:description" content={tool.metaDescription} />
      <meta property="og:url" content={canonical} />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={tool.metaTitle} />
      <meta name="twitter:description" content={tool.metaDescription} />
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(softwareSchema)}</script>
    </Helmet>
  );
}
